import { Search } from 'lucide-react'

import {
  POST_STATUSES,
  STATUS_META,
  type PostSort,
  type PostStatus,
  type RoadmapMeta,
} from '../api/types'
import { cn } from '../lib/cn'

export type ToolbarProps = {
  sort: PostSort
  status: PostStatus | null
  query: string
  meta: RoadmapMeta | undefined
  onSortChange: (sort: PostSort) => void
  onStatusChange: (status: PostStatus | null) => void
  onQueryChange: (query: string) => void
}

const chipClass = (active: boolean): string =>
  cn(
    'rounded-full border px-3.5 py-1.5 font-display text-xs font-medium transition-colors',
    active
      ? 'border-dune-accent bg-orange-50 text-dune-accent'
      : 'border-dune-border bg-white text-dune-text-secondary hover:border-dune-accent',
  )

export const Toolbar = ({
  sort,
  status,
  query,
  meta,
  onSortChange,
  onStatusChange,
  onQueryChange,
}: ToolbarProps): JSX.Element => (
  <div className="flex flex-col gap-4">
    <div className="flex flex-wrap items-center gap-2">
      <button
        type="button"
        className={chipClass(status === null)}
        onClick={() => onStatusChange(null)}
      >
        Todas{meta ? ` · ${meta.total}` : ''}
      </button>

      {POST_STATUSES.map((value) => (
        <button
          key={value}
          type="button"
          className={chipClass(status === value)}
          onClick={() => onStatusChange(value)}
        >
          {STATUS_META[value].label}
          {meta ? ` · ${meta.statusCounts[value]}` : ''}
        </button>
      ))}
    </div>

    <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
      <div className="relative w-full sm:max-w-xs">
        <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-dune-text-secondary" />
        <input
          type="search"
          value={query}
          onChange={(event) => onQueryChange(event.target.value)}
          placeholder="Buscar ideias..."
          className="h-11 w-full rounded-2xl border border-dune-border bg-white pl-9 pr-4 font-sans text-sm text-dune-text outline-none placeholder:text-[#C4C4CC] focus:border-dune-accent focus:ring-2 focus:ring-dune-accent/20"
        />
      </div>

      <div className="flex items-center gap-2">
        <span className="font-display text-xs uppercase tracking-wider text-dune-text-secondary">
          Ordenar
        </span>
        <select
          value={sort}
          onChange={(event) => onSortChange(event.target.value as PostSort)}
          className="h-11 rounded-2xl border border-dune-border bg-white px-3 font-display text-sm text-dune-text outline-none focus:border-dune-accent"
        >
          <option value="popular">Mais votadas</option>
          <option value="recent">Mais recentes</option>
        </select>
      </div>
    </div>
  </div>
)
